<template>
  <div>
    <Loading v-if="!loadStatus" text="Loading Cards..." />

    <div class="select-arena" v-else>
      <div v-if="computedCards.length">
        <!-- Cards Arena here  -->
        <div class="card-arena">
          <div
            class="card-holder no-card"
            :class="{ active: activeCard == 'no card' }"
            @click="handleCard({ id: 'no card', inventoryCount: 1 })"
          >
            <p class="inter">No Card</p>
          </div>

          <div
            class="card-anchor"
            v-for="card in computedCards"
            :key="card.id"
            @click="handleCard(card)"
          >
            <div class="card-checkbox">
              <label class="checkbox-container">
                <input type="checkbox" :checked="activeCard == card.id" />
                <span class="checkmark checkmark-center"></span>
              </label>
            </div>
            <div
              class="card-holder inter"
              :class="{
                active: activeCard == card.id,
                'no-stock': !card.inventoryCount,
                'word-wrap': card.attributes.name.length > 20
              }"
            >
              <p class="none" v-if="!card.inventoryCount">
                Out of Stock
              </p>

              <img
                :src="card.image ? card.image.url : ''"
                :alt="card.image ? card.image.filename : ''"
              />
            </div>
            <div
              class="card-details inter"
              :class="{ 'no-stock': !card.inventoryCount }"
            >
              <p class="name">
                {{ card.attributes ? card.attributes.displayName : '' }}
              </p>

              <div>
                <p>
                  $
                  {{
                    card.attributes ? card.attributes.price : 0 | formatCurrency
                  }}
                </p>
              </div>
            </div>
          </div>
        </div>

        <!-- Quantity Area -->
        <div v-if="computedCondition" class="quantity-arena inter">
          <p>Quantity</p>
          <div class="dropdown-holder">
            <v-select
              class="custom gift-select"
              :options="quantities"
              :clearable="false"
              :searchable="false"
              v-model="payload.quantity"
              @input="$emit('updateQuantity', payload.quantity)"
            >
              <template #open-indicator="{ attributes }">
                <span v-bind="attributes"> <Dropdown /> </span>
              </template>
            </v-select>
          </div>
        </div>
      </div>

      <!-- Empty Cards Region Here -->
      <div class="empty inter" v-else>
        <p>
          No items to display. Add cards to your inventory to view availability here.
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { progressStatus, cardStates, isPrintedCard } from '@/helpers'
// import Dropdown from '../Universal/Dropdown.vue'

export default {
  name: 'card',
  props: ['id'],

  // components: { Dropdown },

  data: () => ({
    activeCard: '',
    quantities: [],
    payload: {
      quantity: 1,
      price: ''
    }
  }),

  created() {
    this.$store.dispatch('cardTemplate/getCards')
  },

  mounted() {
    this.loadSavedCard()
  },

  computed: {
    computedCondition() {
      return (
        this.activeCard &&
        this.activeCard != cardStates.NO_CARD &&
        !this.$route.path.includes(cardStates.REDEMPTION)
      )
    },

    //Condition to return cardtype based on user location
    computedCards() {
      if (this.$route.path.includes(cardStates.REDEMPTION)) {
        return this.cardList.filter(
          card =>
            isPrintedCard(card.attributes && card.attributes.tagList) ||
            isPrintedCard(card.attributes && card.attributes.typeList)
        )
      }
      return this.cardList
    },

    loadStatus() {
      return progressStatus(this.loadCards)
    },

    isSalesForceConnected() {
      return this.$store.getters['integration/isSalesForceConnected']
    },

    ...mapState({
      loadCards: state => state.cardTemplate.loadCards,
      cardList: state => state.cardTemplate.cardList,
      productVariant: state => state.product.variant
    })
  },

  methods: {
    next() {
      if (!this.$route.path.includes('redemption')) {
        return this.$emit('next')
      }

      if (this.$route.fullPath.split('/').includes('edit')) {
        this.$router.push({
          name: 'EditGroupOrderInfo',
          params: { id: this.id }
        })
      } else {
        this.$router.push({ name: 'GroupOrderInfo', params: { id: this.id } })
      }
    },
    handleCard(card) {
      if (!card.inventoryCount) {
        return
      }

      this.quantities = []
      for (let q = 1; q <= card.inventoryCount; q++) {
        this.quantities.push(q)
      }

      this.activeCard = card.id
      this.$emit('handleCard', card)
      localStorage.setItem('selectedCard', JSON.stringify(card))

      if (card.id != cardStates.NO_CARD) {
        // this.$store.dispatch('product/getVariant', card.id)
        this.payload.quantity = 1
        this.payload.price = card.attributes.price
      }
    },

    loadSavedCard() {
      let card = localStorage.getItem('selectedCard')

      if (card) {
        this.handleCard(JSON.parse(card))
      }
    }
  }
}
</script>

<style lang="scss" scoped>
$primary-black: #24292c;

.select-arena {
  .empty {
    display: flex;
    justify-content: center;
    align-items: center;
    margin: auto;
    color: #25282a;
    min-height: 200px;
    p {
      font-size: 0.938rem;
      font-weight: normal;
      span {
        font-size: 0.938rem;
        font-weight: 700;
        text-decoration: none;
        cursor: pointer;
      }
    }
  }

  .card-arena {
    display: flex;
    flex-wrap: wrap;
    margin-top: 0rem;
    grid-column-gap: 1.75rem;

    @media (max-width: 575.98px) {
      justify-content: center;
    }

    @media (min-width: 576px) and (max-width: 767.98px) {
      justify-content: center;
    }

    .card-anchor {
      margin-bottom: 2rem;
      width: 31%;
    }

    .card-details {
      display: flex;
      padding-top: 0.875rem;

      p {
        color: $primary-black;
        font-weight: normal;
        font-size: 0.813rem;

        &.name {
          text-align: left;
          width: 72%;
        }
      }

      div {
        margin-left: auto;
      }
      &.no-stock {
        opacity: 0.2;
      }
    }
  }

  .card-holder {
    position: relative;

    height: 290px;
    border: 1px solid #a09c95;
    cursor: pointer;

    padding: 1.875rem;

    &.word-wrap {
      padding: 2.5rem 1.875rem;
    }

    @media (max-width: 575.98px) {
      width: 100%;
      margin: 0px 0px 25px 0px;
    }

    @media (min-width: 576px) and (max-width: 767.98px) {
      width: 100%;
      margin: 0px 0px 25px 0px;
    }

    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }

    &.no-card {
      width: 31%;
      border: none;
      background: transparent;
      display: flex;
      justify-content: center;
      align-items: center;
      border: 1px solid #a09c95;

      p {
        font-size: 0.913rem;
        color: #25282a;
      }
    }

    &.active {
      border: 2px solid $primary-black;
    }

    &.no-stock {
      cursor: not-allowed;
      border: 1px solid #d0d0d0;
      background: rgba(255, 255, 255, 0.53);
      .none {
        bottom: 50%;
        z-index: 2;
        position: absolute;
        font-weight: bold;
        left: 30%;
      }
      img {
        opacity: 0.2;
      }
    }
  }
}

.card-checkbox {
  position: relative;
  top: 0.8rem;
  left: 0.8rem;
}

.quantity-arena {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin: 1.5rem 0;

  p {
    font-weight: bold;
    color: $primary-black;
    width: 17%;
    text-align: left;

    @media (max-width: 767.98px) {
      width: 100%;
    }
  }

  .dropdown-holder {
    width: 12%;
    @media (max-width: 767.98px) {
      width: 100%;
    }
  }
}
@media (max-width: 800px) {
  .card-anchor {
    width: auto !important;
  }
  .select-arena .card-holder.no-card {
    width: 230.8px;
  }
  .card-anchor {
    width: 230.8px !important;
  }
}
</style>
